var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuestCtaArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.323047 2.18363C2.807 -0.145075 11.8458 -0.731529 18.4696 1.01069C27.8361 3.47739 30.8722 8.73853 28.4055 18.2603C27.1118 23.2972 24.8348 31.1975 24.9728 31.1975C25.0073 31.1975 25.9214 30.5421 27.0081 29.7313C30.4926 27.1266 32.3729 26.4021 33.2699 27.2991C33.6322 27.6614 33.4424 27.8684 31.338 29.3001C31.3207 29.3173 28.2848 31.3355 23.3686 35.372C20.4707 37.7352 20.5224 36.3897 20.4707 33.4228C20.4017 30.3178 20.1084 28.4031 19.6254 26.1089C19.3495 24.8152 18.7802 23.1075 20.4189 22.8487C21.7299 22.6417 22.8511 24.8669 23.2479 28.7481C23.4031 30.2833 23.5065 30.1453 24.2482 27.1956C24.6104 25.7467 25.1798 23.6939 25.4903 22.6417C28.9575 11.119 26.7841 6.34083 16.8655 3.68438C13.3466 2.73565 6.53289 2.33889 3.73844 2.89088C0.823253 3.47737 -0.711932 3.16686 0.323047 2.18363Z",
    fill: "#35C0FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestCtaArrow);
export default __webpack_public_path__ + "static/media/guest-cta-arrow.b378f436fe5ebe32c9ea15dbbd3cb03537a6ed941dcc71d1c97af2b00e64de16.svg";
export { ForwardRef as ReactComponent };